import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { Subject } from 'rxjs';
import { NgModel } from '@angular/forms';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { IAccessRightFilterCollection } from '@fi-shared/models';
import { FiSnackBarService } from '@fi-shared/fi-snackbar/snack-bar.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-task-edit',
    template: `
        <form
            name="fiTasksForm"
            (fiValidatingForm)="onFormValidateSuccess()"
            (fiValidatingFormError)="onFormValidateError($event)"
            #editForm="fiValidatingForm"
            novalidate
        >
            <fi-task-edit-task
                [task]="task"
                [accessRightFilterCollection]="accessRightFilterCollection"
                (saveClick)="onSaveClick()"
            >
            </fi-task-edit-task>
        </form>
    `,
    styleUrls: ['./task-edit.component.scss'],
    host: { class: 'fi-task-edit' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class TaskEditComponent implements OnInit, OnDestroy {
    @Input() task: ITask;
    @Input() accessRightFilterCollection: IAccessRightFilterCollection;
    @Output() saveCompleted = new EventEmitter<number>();

    @ViewChild('editForm', { static: true }) validatingFormComponent: FiValidatingFormDirective;

    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private taskSharedService: FiTaskSharedService,
        private snackBar: FiSnackBarService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        this.saveChangesWarningService.start(() => this.task);
    }

    ngOnDestroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    onSaveClick() {
        this.validatingFormComponent.submit();
    }

    onFormValidateSuccess() {
        this.taskSharedService.saveTask(this.task, false).then((newTaskId) => {
            this.saveChangesWarningService.stop();
            this.saveCompleted.next(newTaskId);
            this.snackBar
                .showSnackbar({
                    textMessage: this.appTextService.get('task.task_saved'),
                    buttonText: this.appTextService.get('task.view_task'),
                })
                .onAction()
                .subscribe(() => {
                    this.fiStateService.go(FiStateNames.Task.Details, { id: newTaskId });
                });
        });
    }

    onFormValidateError($event: NgModel[]) {
        this.fiDialogsService.notify({
            messageText: this.appTextService.get('common.error_all_mandatory'),
            headerText: this.appTextService.get('common.warning'),
        });
    }
}
